import Vue from 'vue'
import VueAuth from '../utils/auth'

Vue.use(VueAuth)

export default function ({ app }, inject) {
  app.$auth = Vue.prototype.$auth
  inject('auth', Vue.prototype.$auth)
}
